import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { projectsService } from '../services/projects'
import { toast } from 'sonner'

/**
 * When user navigates to /project/workspace, redirect to the first project's workspace.
 */
export default function RedirectToFirstProjectWorkspace() {
  const navigate = useNavigate()
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    let cancelled = false
    async function run() {
      try {
        const projects = await projectsService.list({ limit: 1 })
        if (cancelled) return
        if (projects.length > 0) {
          navigate(`/project/${projects[0].id}`, { replace: true })
        } else {
          toast.info('No projects yet. Create a project first.')
          navigate('/project', { replace: true })
        }
      } catch {
        if (!cancelled) {
          toast.error('Failed to load projects')
          navigate('/project', { replace: true })
        }
      } finally {
        if (!cancelled) setChecking(false)
      }
    }
    run()
    return () => { cancelled = true }
  }, [navigate])

  if (!checking) return null
  return (
    <div className="flex items-center justify-center min-h-[200px] text-[#829ab1]">
      Opening project workspace...
    </div>
  )
}
